module.exports = __webpack_public_path__ + "static/media/group.690b9cb4.png";